// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__f11iT","Label":"BuildControl_Label__1Q1XC","Less":"BuildControl_Less__2hkIN","More":"BuildControl_More__3EMoy"};